// extracted by mini-css-extract-plugin
export var item = "program-benefits-item-module--item--0xPeO";
export var title = "program-benefits-item-module--title--iKihE";
export var description = "program-benefits-item-module--description--fHQyk";